/**
 * Returns true when the page is being rendered by a headless browser
 * (e.g. Puppeteer or Playwright used for scheduled report PDF generation).
 *
 * Headless browsers set navigator.webdriver = true per the WebDriver spec.
 * This flag is used to force light-mode for PDF exports so that user dark-mode
 * preferences do not bleed into generated report output.
 */
export function isHeadlessBrowser(): boolean {
  return navigator.webdriver === true;
}
